!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Toggle nav small container.
   */
  Drupal.behaviors.pageHeader = {
    attach: context => {
      $(once('pageHeader', '.js-page-header', context))
        .each(function() {
          const $pageHeader = $(this);
          $(window).on('scroll', function() {
            const distanceY = window.pageYOffset ||
              document.documentElement.scrollTop;
            const shrinkOn = 100;
            if (distanceY > shrinkOn) {
              $pageHeader.addClass('js-page-header-is-condensed');
            }
            else {
              $pageHeader.removeClass('js-page-header-is-condensed');
            }
          });
        });
    },
  };
})(document, Drupal, jQuery, once);
